import { DocumentAddCommandResultValidationResult } from '../../easyclaim.api.client.typescript/src';

import { FeedbackMode } from './ImageRecognitionFeedback2';

export function getAdditionalFeedback(
	mode: FeedbackMode,
	validationResults: DocumentAddCommandResultValidationResult[] | null
) {
	const multipleForm = (validationResults?.length ?? 0) > 1;

	if (mode === FeedbackMode.Main) {
		if (multipleForm) {
			return 'additionalFeedback';
		} else {
			return 'additionalFeedbackForSingleValidation';
		}
	} else {
		if (multipleForm) {
			return 'imageRecognitionMismatchModal.additionalFeedback';
		} else {
			return 'imageRecognitionMismatchModal.additionalFeedbackForSingleValidation'; // should change to single form in future
		}
	}
}
